module.exports = __webpack_public_path__ + "02a2f8d39a3b1a067ebccf96389db943.svg";